import { Editor as SlateEditor, type Range, type RangeRef } from 'slate';

import {
  type DetectedBrandTerm,
  getDetectedBrandTermType,
  getDetectedBrandTermTypeHighlightMark,
} from 'src/data/brandTerm';
import type { HighlightMarkType } from 'src/data/markedText';

import { createSlateRange } from './queries';

interface DecoratedRange extends Range {
  decoration?: HighlightMarkType;
}

export const createDetectedBrandTermsRangeRefs = (
  editor: SlateEditor,
  detectedBrandTerms: DetectedBrandTerm[]
): RangeRef[] => {
  if (!detectedBrandTerms || detectedBrandTerms.length === 0) {
    return [];
  }

  const result: RangeRef[] = [];

  detectedBrandTerms.forEach((detectedBrandTerm) => {
    const { termStartPosition, termEndPosition } = detectedBrandTerm;

    const range = createSlateRange(editor, termStartPosition, termEndPosition);
    if (!range) {
      return;
    }

    const detectedBrandTermType = getDetectedBrandTermType(detectedBrandTerm);
    const rangeRef = SlateEditor.rangeRef(
      editor,
      {
        ...range,
        decoration: detectedBrandTermType
          ? getDetectedBrandTermTypeHighlightMark(detectedBrandTermType)
          : undefined,
        data: detectedBrandTerm,
      } as DecoratedRange,
      { affinity: 'inward' }
    );
    result.push(rangeRef);
  });

  return result;
};
